import React from "react";

const ForgotPasswordPage = () => {
  return <div>ForgotPasswordPage</div>;
};

export default ForgotPasswordPage;
